const firebaseConfig = {
  apiKey: "AIzaSyCRsyoDFqyJi_K4slsNQ1tnExcwrgSVvOA",
  authDomain: "travel-guru-site-bf23c.firebaseapp.com",
  databaseURL: "https://travel-guru-site-bf23c.firebaseio.com",
  projectId: "travel-guru-site-bf23c",
  storageBucket: "travel-guru-site-bf23c.appspot.com",
  messagingSenderId: "975526471068",
  appId: "1:975526471068:web:a1ea87cb29ba4af7c59459"
};
export default firebaseConfig;